import styled, { css } from 'styled-components';

interface OwnProps {
  auto?: boolean;
}

const Column = styled.div<OwnProps>`
  flex-basis: 33.33%;
  flex-grow: 1;
  padding: 0 1px;

  ${({ auto }) =>
    auto &&
    css`
      -webkit-box-flex: 0;
      flex: 0 0 auto;
      width: auto;
    `};
`;

export default Column;
